const Header = () => {
  return (
    <div className="head"> Google Calculator </div>
  )
}

export default Header